import React, { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { API_URL } from '../config/api';

export default function WebAuthForm({ onAuth }) {
    const [step, setStep] = useState('email');
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSendEmail = async () => {
        // Special test account bypass for performance testing scripts (development only)
        if (process.env.NODE_ENV !== 'production' && email === 'test@test') {
            setStep('otp');
            setLoading(false);
            return;
        }

        const url = `${API_URL}otp/send_otp`;

        setError('');
        setLoading(true);
        try {
            const resp = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });
            if (resp.ok) {
                setStep('otp');
            } else {
                setError('Failed to send email');
            }
        } catch (e) {
            setError('Network error');
        }
        setLoading(false);
    };

    const handleSendOtp = async () => {
        const url = `${API_URL}otp/verify_otp`;
        setError('');
        setLoading(true);
        try {
            const resp = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, otp }),
            });
            if (resp.ok) {
                const { token, locale, timezone, design_version } = await resp.json();
                onAuth({ token, locale, timezone, designVersion: design_version || 2 });
            } else {
                setError('Invalid code');
            }
        } catch (e) {
            setError('Network error');
        }
        setLoading(false);
    };

    return (
        <Box sx={{ maxWidth: 360, mx: 'auto', mt: 10, p: 3, bgcolor: 'background.paper', borderRadius: 3, boxShadow: 3 }}>
            <Typography variant="h5" align="center" sx={{ mb: 2, fontWeight: 700 }}>
                Sign in
            </Typography>
            {step === 'email' && (
                <>
                    <TextField
                        label="Email"
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        fullWidth
                        autoFocus
                        margin="normal"
                        variant="outlined"
                        inputProps={{ autoComplete: 'email' }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        size="large"
                        sx={{ mt: 2, borderRadius: 2 }}
                        onClick={handleSendEmail}
                        disabled={!email || loading}
                    >
                        {loading ? 'Sending...' : 'Get code'}
                    </Button>
                </>
            )}
            {step === 'otp' && (
                <>
                    <TextField
                        label="Enter code from email"
                        type="text"
                        value={otp}
                        onChange={e => setOtp(e.target.value)}
                        fullWidth
                        autoFocus
                        margin="normal"
                        variant="outlined"
                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 8 }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        size="large"
                        sx={{ mt: 2, borderRadius: 2 }}
                        onClick={handleSendOtp}
                        disabled={!otp || loading}
                    >
                        {loading ? 'Checking...' : 'Sign in'}
                    </Button>
                </>
            )}
            {error && <Typography color="error" align="center" sx={{ mt: 2 }}>{error}</Typography>}
        </Box>
    );
} 